// The colour theme (grooming W1): follows the system until the person picks one, which localStorage keeps.
// orca.css answers `data-theme` on <html>: no attribute means the system's `prefers-color-scheme`.
export type Theme = 'system' | 'light' | 'dark'

export const THEME_KEY = 'orca.theme'
export const themes: readonly Theme[] = ['system', 'light', 'dark']

/** The kept choice; an unknown value or a blocked storage (private mode, policy) reads as the system. */
export function readTheme(): Theme {
  try {
    const kept = localStorage.getItem(THEME_KEY)
    return themes.find((it) => it === kept) ?? 'system'
  } catch {
    return 'system'
  }
}

export function saveTheme(theme: Theme) {
  try {
    if (theme === 'system') localStorage.removeItem(THEME_KEY)
    else localStorage.setItem(THEME_KEY, theme)
  } catch {
    // Not kept: the choice lasts until the tab closes.
  }
}

export function applyTheme(theme: Theme) {
  const root = document.documentElement
  if (theme === 'system') delete root.dataset.theme
  else root.dataset.theme = theme
}

export const nextTheme = (theme: Theme): Theme => themes[(themes.indexOf(theme) + 1) % themes.length] ?? 'system'
